// React imports
import { useMemo } from 'react';

// MUI imports
import { blue } from '@mui/material/colors';

// Local imports
import { useDropzone } from 'react-dropzone'

function StyledDropzone(props) {
    const { onDrop, accept } = props;
    const {
        getRootProps,
        getInputProps,
        isFocused,
        isDragAccept,
        isDragReject
    } = useDropzone({ onDrop, accept, maxFiles: 1 });

    const style = useMemo(() => ({
        ...baseStyle,
        ...(isFocused ? focusedStyle : {}),
        ...(isDragAccept ? acceptStyle : {}),
        ...(isDragReject ? rejectStyle : {})
    }), [
        isFocused,
        isDragAccept,
        isDragReject
    ]);

    return (
        <div className='container'>
            <div {...getRootProps({style})}>
                <input {...getInputProps()} />
                <p>Drag files here, or <span style={{ color: blue[500] }}>click to select files</span></p>
            </div>
        </div>
    );
}

export default StyledDropzone;

const baseStyle = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
    borderWidth: 2,
    borderRadius: 2,
    borderColor: '#eeeeee',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out',
    cursor: 'pointer'
};

const focusedStyle = {
    borderColor: '#2196f3'
};

const acceptStyle = {
    borderColor: '#00e676'
};

const rejectStyle = {
    borderColor: '#ff1744'
};